import AdminLayout from '@/layouts/AdminLayout';
import {
	BlogPosts,
	CreateBlogPost,
	EditBlogPost,
	Clinics,
	CreateClinic,
	CreateSession,
	Professionals,
	Sessions,
	SessionParticipantsPage,
	Users,
	EditUser,
	EditProfessional,
	AdminProfessionalPatients,
	AdminProfessionalMonthlyUsage,
	Faq,
	CreateFaq,
	Forms,
	EditForm,
	MatchAdminPage,
	MatchSimulatorPage,
	SandboxPage,
	SandboxScenarioPage,
} from '@/pages';
import { AdminLogin } from '@/pages/admin/auth/AdminLogin';
import { EditClinic } from '@/pages/admin/clinics/EditClinic';
import { ClubsPage } from '@/pages/admin/clubs/ClubsPage';
import { CompaniesSection } from '@/pages/admin/companies/CompaniesSection';
import { CompanyDetails } from '@/pages/admin/companies/CompanyDetails';
import { CompanyDashboardPage } from '@/pages/admin/companies/CompanyDashboardPage';
import { CreateCompany } from '@/pages/admin/companies/CreateCompany';
import Dashboard from '@/pages/admin/home/Dashboard';
import { ResourcesPage } from '@/pages/admin/resources/ResourcesPage';
import { Admins } from '@/pages/admin/admins/Admins';
import { Support } from '@/pages/admin/support/Support';
import { Navigate, RouteObject } from 'react-router-dom';

export const adminRoutes: Array<RouteObject> = [
	{
		path: '/admin/login',
		element: <AdminLogin />,
	},
	{
		path: '/admin',
		element: <AdminLayout />,
		children: [
			{
				index: true,
				element: <Navigate to="dashboard" replace />,
			},
			{
				path: 'dashboard',
				element: <Dashboard />,
			},
			{
				path: 'empresas',
				children: [
					{
						path: '',
						element: <CompaniesSection />,
					},
					{
						path: 'criar',
						element: <CreateCompany />,
					},
					{
						path: ':id/dashboard',
						element: <CompanyDashboardPage />,
					},
					{
						path: ':id',
						element: <CompanyDetails />,
					},
				],
			},
			{
				path: 'profissionais',
				children: [
					{
						path: '',
						element: <Professionals />,
					},
					{
						path: 'editar/:id',
						element: <EditProfessional />,
					},
					{
						path: 'editar/:id/pacientes',
						element: <AdminProfessionalPatients />,
					},
					{
						path: 'editar/:id/uso',
						element: <AdminProfessionalMonthlyUsage />,
					},
				],
			},
			{
				path: 'clinicas',
				children: [
					{
						path: '',
						element: <Clinics />,
					},
					{
						path: 'criar',
						element: <CreateClinic />,
					},
					{
						path: 'editar/:id',
						element: <EditClinic />,
					},
				],
			},
			{
				path: 'pacientes',
				children: [
					{
						path: '',
						element: <Users />,
					},
					{
						path: 'editar/:id',
						element: <EditUser />,
					},
				],
			},
			{
				path: 'consultas',
				children: [
					{
						path: '',
						element: <Sessions />,
					},
					{
						path: 'agendar',
						element: <CreateSession />,
					},
					{
						path: ':sessionId/participantes',
						element: <SessionParticipantsPage />,
					},
				],
			},
			{
				path: 'blog',
				children: [
					{
						path: '',
						element: <BlogPosts />,
					},
					{
						path: 'criar',
						element: <CreateBlogPost />,
					},
					{
						path: 'editar/:id',
						element: <EditBlogPost />,
					},
				],
			},
			{
				path: 'faq',
				children: [
					{
						path: '',
						element: <Faq />,
					},
					{
						path: 'criar',
						element: <CreateFaq />,
					},
				],
			},
			{
				path: 'clubes',
				element: <ClubsPage />,
			},
			{
				path: 'recursos',
				element: <ResourcesPage />,
			},
			{
				path: 'formularios',
				children: [
					{
						path: '',
						element: <Forms />,
					},
					{
						path: ':id',
						element: <EditForm />,
					},
				],
			},
			{
				path: 'match',
				children: [
					{
						path: '',
						element: <MatchAdminPage />,
					},
					{
						path: 'simulador',
						element: <MatchSimulatorPage />,
					},
				],
			},
			{
				path: 'sandbox',
				children: [
					{
						path: '',
						element: <SandboxPage />,
					},
					{
						path: ':id',
						element: <SandboxScenarioPage />,
					},
				],
			},
			{
				path: 'admins',
				element: <Admins />,
			},
			{
				path: 'suporte',
				element: <Support />,
			},
		],
	},
];
